import * as React from 'react';
import { TCssTextAlign, UIText2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import * as styles from './FormCardLayout.css';

export const FormCardLayout = ({
  question,
  children,
  image,
  imageMobile,
  dataTestId,
  verticallyCenteredContent = false,
  formGap = 24,
  formMobileTextAlign = 'left',
  wide = false,
  legend,
}: {
  question: string;
  children: React.ReactNode;
  image: string;
  imageMobile: string;
  dataTestId?: string;
  verticallyCenteredContent?: boolean;
  formGap?: number;
  formMobileTextAlign?: TCssTextAlign;
  wide?: boolean;
  legend?: string;
}): React.JSX.Element => {
  const style = {
    '--form-gap': `${formGap}px`,
    '--form-mobile-text-align': `${formMobileTextAlign}`,
  } as React.CSSProperties;

  return (
    <div data-testid={dataTestId} className={styles['card']} style={style}>
      <div
        className={clsx(
          styles['form'],
          verticallyCenteredContent && styles['vertically-centered'],
          wide && styles['wide'],
        )}
      >
        <div className={styles['question']}>
          {legend && (
            <div className={styles['legend']}>
              <UIText2 color="text-secondary-default">{legend}</UIText2>
            </div>
          )}
          {question}
        </div>
        <div>{children}</div>
      </div>
      <div className={styles['image']}>
        <picture>
          <source media="(max-width: 1023px)" srcSet={imageMobile} type="image/png" />
          <source media="(min-width: 102px)" srcSet={image} type="image/png" />
          <img src={imageMobile} alt={''} loading="lazy" decoding="async" />
        </picture>
      </div>
    </div>
  );
};
